export default "__VITE_ASSET__DIHxm8Bd__"